import React, { useState } from "react";
import ReactDOM from "react-dom";
import styles from "./sidemodal.module.css";
import closeImg from "../../public/images/cross.png";
import { Spinner } from "react-bootstrap";
import Button from "../../Common/Button/Button";

const SideModal = (props) => {
  const [errorMessage, setErrorMessage] = useState("");

  const handleConfirmButton = () => {
    setErrorMessage("");
    props.setOpenSideModal(false);
  };

  return ReactDOM.createPortal(
    <>
      {props.open ? (
        <div className={styles.modalBody}>
          <div
            onClick={() => {
              props.setOpenSideModal(false);
              props.setRoles("");
            }}
          >
            <img className={styles.crossImage} alt="" src={closeImg} />
          </div>
          {props.loader === true ? (
            <div className={styles.spinner}>
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              <div className={styles.head}>
                <h3>{props.header}</h3>
              </div>
              <div className={styles.productList}>
                {props.product.map((item, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => props.setSelectedProduct(item.value)}
                      className={
                        props.selectedProduct === item.value
                          ? styles.selectedProductDiv
                          : styles.ProductDiv
                      }
                    >
                      {item.title}
                    </div>
                  );
                })}
              </div>
              {props.children}
              <div
                className={styles.confirmButtonDiv}
                style={{ position: "absolute", bottom: "30px", width: "100%" }}
              >
                {errorMessage !== "" && (
                  <div className={styles.errorDiv}>{errorMessage}</div>
                )}
                <Button handleClick={handleConfirmButton} heading={"Confirm"} />
              </div>
            </>
          )}
        </div>
      ) : (
        ""
      )}
    </>,
    document.getElementById("modal-root")
  );
};

export default SideModal;
